<template>
<v-card @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title primary-title>
        <div class="hotel-card-title pa-2">
            {{ $t('hotel.card.geolocation.title') }}
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="procent" @click="status_dialog = true">
                    <span :class="color + '--text'">
                        {{ procent_status }}%
                    </span>
                    <v-icon size="19" :color="color">info</v-icon>
                </div>
            </template>
            <div class="">
                <div class=" important white--text">
                    Rata completare <span class="text-lowercase"> {{ $t('hotel.card.geolocation.title') }} </span>
                </div>
                <div class="">
                    Adresa este necesara pentru o mai buna localizare de catre turisti
                </div>
            </div>
        </v-tooltip>
        <v-icon class="pa-1 icon-edit" color="#5A8DEE" v-show="hover" @click="emitOpenDialog()">edit</v-icon>
    </v-card-title>
    <v-card-text>
        <div>
            {{item.static.geo.region}}
            <span class="pr-1">,</span>
            {{item.static.geo.city}}
        </div>
        <div>
            {{item.static.geo.address}}
            <span v-if="item.static.geo.postcode" class="pr-1">,</span>
            {{item.static.geo.postcode}}
        </div>
    </v-card-text>

    <!--info dialog-->
    <v-dialog v-model="status_dialog" max-width="720">
        <v-card>
            <v-card-title class="hotel-card-title" primary-title>
                Info
            </v-card-title>
            <v-card-text class="info-text">
                <div class="">
                    Adresa este necesara pentru o mai buna localizare de catre turisti
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="status_dialog=false">
                    {{ $t('button.exit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./info dialog -->
</v-card>
</template>

<script>
import {
    mapActions
} from "vuex";


export default {
    props: {
        item: Object,
        config: Object,
        active: Object
    },
    name: `item-hotel`,

    data() {
        return {
            status_dialog: false,
            color: 'grey',
            hover: false,
        };
    },
    watch: {},

    computed: {
        procent_status() {
            let procent = 0;
            if(this.item.static.geo.region) {
                procent += 20
            }
            if(this.item.static.geo.city) {
                procent += 25
            }
            if(this.item.static.geo.postcode) {
                procent += 15
            }
            if(this.item.static.geo.address) {
                procent += 20
            }
            if(this.item.static.defaults.timezone) {
                procent += 10
            }
            if(this.item.country_code) {
                procent += 10
            }

            this.setColor(procent);
            return procent;
        }
    },

    methods: {
        ...mapActions("alert", ["success", "error"]),

        setColor(procent) {
            if(procent < 51) {
                this.color = 'red'
            }
            if(50 < procent && procent < 81) {
                this.color = 'orange'
            }
            if(procent > 80) {
                this.color = 'green'
            }
        },

        emitOpenDialog() {
            this.$emit('openDialog');
        }
    },
};
</script>
